import { Component } from "@angular/core";

/**
 * Minimal no-op component used for routes that are handled entirely by guards.
 * This component should never actually render since guards redirect before activation.
 */
@Component({
  template: "",
  selector: "app-no-op",
  standalone: true,
})
export class NoOpComponent {}
